import {
  BinarySkillFilePreview,
  CsvSkillFilePreview,
  isBinarySkillFileContent,
} from "@promptlayer/ui";

export const SkillFileDiffPreview = ({
  path,
  content,
  originalContent,
}: {
  path: string;
  content: string;
  originalContent?: string;
}) => {
  if (isBinarySkillFileContent(content)) {
    return <BinarySkillFilePreview content={content} compact />;
  }

  if (path.toLowerCase().endsWith(".csv")) {
    return <CsvSkillFilePreview content={content} compact originalContent={originalContent} />;
  }

  return null;
};
